import type { BaseMessage, UserMessage } from '@sendbird/chat/message';

/** Trim leading/trailing whitespace so empty lines do not appear above message text. */
export function trimMessageTextForDisplay(message: BaseMessage): BaseMessage {
  if (message.messageType !== 'user') {
    return message;
  }

  const userMessage = message as UserMessage;
  const original = userMessage.message ?? '';
  const trimmed = original.trim();

  if (trimmed === original) {
    return message;
  }

  const copy = Object.create(Object.getPrototypeOf(userMessage)) as UserMessage;
  Object.defineProperties(copy, Object.getOwnPropertyDescriptors(userMessage));
  Object.defineProperty(copy, 'message', { value: trimmed, enumerable: true, configurable: true, writable: true });
  if (userMessage.mentionedMessageTemplate != null) {
    Object.defineProperty(copy, 'mentionedMessageTemplate', {
      value: userMessage.mentionedMessageTemplate.trim(),
      enumerable: true,
      configurable: true,
      writable: true,
    });
  }
  return copy;
}
